import Rails from "@rails/ujs"
import { Controller } from '@stimulus/core'
const debounce = require('lodash.debounce');

export default class extends Controller {
    static targets  = [ "form", "output"]
    static values   = { url: String }

    connect() {
        this.handleChange = debounce(this.handleChange, 250, {leading: true, trailing: true}).bind(this)
    }

    handleChange(event) {
        let input = event.target,
            selectionStart = input.selectionStart,
            selectionEnd = input.selectionEnd,
            value = input.value,
            isSelector = false;
        if (["select", "select-multiple"].indexOf(input.type) > -1) {
            value = input.selectedOptions;
        }
        $(input).removeClass('is-valid');
        Rails.ajax({
            url: this.urlValue,
            type: "POST",
            data: new FormData(this.formTarget),
            success: (data) => {
                let d = document.createElement('div'),
                    selector = input.id;
                d.innerHTML = data;
                let v = d.querySelector('#'+selector).value,
                    i = document.getElementById(selector +'_saved');
                if (i)
                    i.innerHTML = v;
                $(input).addClass('is-valid');
                // this.outputTarget.innerHTML = data;
                // input = document.getElementById(input.id);
                // this.moveCursorToEnd(input, selectionStart, selectionEnd, value);
            },
        })
    }

    moveCursorToEnd(element, selectionStart, selectionEnd, value) {
        if (["select", "select-multiple"].indexOf(element.type) > -1)
            element.selectedOptions = value
        else
            element.value = value
        if (typeof element.selectionStart == "number") {
            element.focus();
            element.selectionStart = selectionStart;
            element.selectionEnd = selectionEnd;
        } else if (typeof element.createTextRange != "undefined") {
            element.focus();
            var range = element.createTextRange();
            range.collapse(false);
            range.select();
        }
    }
}